import { useDrawer } from './useDrawer';

interface GetDrawerProps {
  isActive: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
  isChild?: boolean;
}

export const getMockDrawer = ({
  isActive,
  openDrawer,
  closeDrawer,
  isChild = false,
}: GetDrawerProps): ReturnType<typeof useDrawer> => ({
  initiatorProps: {
    'aria-controls': '',
    'aria-expanded': false,
    onClick: openDrawer,
  },
  drawerProps: {
    id: '',
    isActive,
    position: 'right',
    hasBackdrop: false,
    onBlDrawerClose: closeDrawer,
  },
  isDrawerOpen: isActive,
  openDrawer,
  closeDrawer,
  isChild,

  // Deprecated props
  drawerControl: {
    isActive,
    open: openDrawer,
    close: closeDrawer,
  },
  handleOpen: openDrawer,
  handleClose: closeDrawer,
});
